
import {default as Group} from './../../zviz2/zviz/components/group';
import {PanelBlueprint} from './panel';
import {extend, cloneObject} from './../../zviz2/zviz/functions';
import {styleHeader2} from './../../styles';

const styleHeader = extend({
    backgroundColor: '#230050',
    borderBottom: '2px solid rgb(38, 48, 98)',
    color: 'white',
    paddingLeft: '15px',
    fontSize: '14pt'
}, styleHeader2);

let PanelBlueBlueprint = cloneObject(PanelBlueprint);

PanelBlueBlueprint.children[0] = (parent) => (extend({
    properties:{
        style: cloneObject(styleHeader),
        content: parent.getTitle()
    }
}, Group) );


export default PanelBlueBlueprint;
export { PanelBlueBlueprint};
